import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useClientContext } from "clients";
import { useStateContext } from "state";

const useDeleteUser = () => {
  const queryClient = useQueryClient();
  const clients = useClientContext();
  const state = useStateContext();
  return useMutation({
    mutationFn: (id: number) => clients.management.deleteUser(id),
    onSuccess: () => {
      if (state.user)
        queryClient.invalidateQueries(["listUsers", state.user.id]);
    },
  });
};
export default useDeleteUser;
